<template>
  <div>
    <sub-header :micrositeUrl="micrositeUrl" />
    <div class="box__svg">
      <div style="width: 80%; margin: auto;">
        <h1 class="caption__select">
          <span>Seleccione una sección, clic para ver detalles</span>
        </h1>
        
        <!-- Mostrar loader mientras carga -->
        <div v-if="!dataLoaded" style="text-align: center; padding: 50px;">
          <p>Cargando...</p>
        </div>
        
        <!-- SVG solo se muestra cuando los datos están listos -->
        <svg
          v-else
          version="1.1"
          id="Capa_1"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          viewBox="0 0 7988 6052"
          style="enable-background: new 0 0 1200 750"
          xml:space="preserve"
          @click="showCoordinatesOnConsole"
        >
          <image
            style="overflow: visible;"
            width="7988"
            height="6052"
            xlink:href="https://kiritek-web-documents.s3.us-west-2.amazonaws.com/masterplan-dashboard/imgs/clubdegolf/MainClubGolfRecortadaV2.png"
          ></image>
          <polygon
            class="polygon"
            v-for="(location, index) in development_data"
            @click.stop="selectLocation(location.id == '89' ? location.id : location.id == '93' ? location.level : '235&236')"
            :key="index"
            :style="{ fill: '#' + location.color, opacity: 0.6 }"
            :points="location.coords"
            :data-location-id="location.id"
            :data-name="location.name"
            v-tippy="{
              content: renderTooltip(location),
              theme: 'honeybee',
              size: 'large',
              distance: 3,
              arrow: true,
              interactive: true,
              animation: 'fade',
              allowHTML: true,
              ignoreAttributes: true
            }"
          />
        </svg>
      </div>
    </div>
  </div>
</template>

<script>
import SubHeader from "../../core/SubHeader.vue";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "Main",
  components: {
    SubHeader,
  },
  data() {
    return {
      url: "clubdegolf",
      micrositeUrl: "https://tresmarias.com.mx/clubdegolf/terrenos",
      coordinates: [],
      torreEtapaInfo: {},
      dataLoaded: false, // ✅ Agregar bandera de carga
      development_data: {
        locationERM: {
          id: 89,
          level: 274,
          totAvailable: null,
          type: "SECCION C38",
          name: "SECCION C38",
          position: "top",
          shape: "poly",
          color: "31af67",
          coords: "",
        },
        locationG3G4G5B9B11: {
          id: 84,
          level: 235,
          totAvailable: null,
          type: "GB",
          name: "SECCION GB",
          position: "top",
          shape: "poly",
          color: "31af67",
          coords: "",
        },
        locationMH: {
          id: 84,
          level: 236,
          totAvailable: null,
          type: "MH",
          name: "MANZANA H",
          position: "top",
          shape: "poly",
          color: "31af67",
          coords: "",
        },
        locationD13: {
          id: 93,
          level: 310,
          totAvailable: null,
          type: "D13",
          name: "PRIVADA D13",
          position: "top",
          shape: "poly",
          color: "31af67",
          coords: "",
        },
      },
    };
  },
  computed: {
    ...mapGetters({
      locations: "getLocations",
    }),
  },
  methods: {
    ...mapActions(["getTotAvailableLocations", "getTowerStageLevels", "clearCoords"]),
    selectLocation(location) {
      console.log(location);
      this.$router.push({ path: `/clubdegolf/preseccion/${location}` });
    },
    showCoordinatesOnConsole(event) {
          const svg = event.target.closest('svg');
          const point = svg.createSVGPoint();

          point.x = event.clientX;
          point.y = event.clientY;

          const svgPoint = point.matrixTransform(svg.getScreenCTM().inverse());

          // Guardar coordenadas en la lista
          this.coordinatesList.push(`${svgPoint.x.toFixed(2)},${svgPoint.y.toFixed(2)}`);

          // Imprimir TODAS las coordenadas en un string
          //const output = this.coordinatesList.join(' ');
          //console.log(output);
        },
    renderTooltip(location) {
      const totalAvailable = location.totAvailable ?? 0;
      const availableText = totalAvailable > 0 ? totalAvailable : "No disponible";

      return `
        <div class="tool">
          <div class="tool__content">
            <p>UBICACIÓN: <b style="font-size: small;">${location.name || ''}</b></p>
            <p>DISPONIBLE: <b class="disponible">${availableText}</b></p>
          </div>
        </div>
      `;
    }
  },
  async created() {
    try {
      for (const [key, value] of Object.entries(this.development_data)) {
        await this.getTowerStageLevels(value);
        
        const torreInfo = this.locations;
        
        if (Array.isArray(torreInfo) && torreInfo.length > 0) {
          const matchingLevel = torreInfo.find(info => info.id === value.level);
          
          if (matchingLevel) {
            this.development_data[key].totAvailable = matchingLevel.available;
            this.development_data[key].color = matchingLevel.color;
            
            if (matchingLevel.available > 0) {
              this.development_data[key].coords = matchingLevel.coords;
            }
            
            this.torreEtapaInfo[value.id] = matchingLevel;
          }
        }
      }
    } catch (error) {
      console.error('Error cargando datos de ubicaciones:', error);
    } finally {
      // ✅ Marcar como cargado cuando termine (con error o sin error)
      this.dataLoaded = true;
    }
  },
  async beforeDestroy() {
    await this.clearCoords();
  }
};
</script>